import { mdiViewDashboard, mdiCog, mdiShieldAccount, mdiBrightnessPercent, mdiAccountGroup, mdiCurrencyUsd, mdiHelpCircle } from '@mdi/js'

export default [
  {
    title: 'Dashboard',
    icon: mdiViewDashboard,
    to: 'manager-dashboard',
    action: 'read',
    resource: 'Manager',
  },
  {
    title: 'Usuários',
    icon: mdiAccountGroup,
    to: 'manager-usuarios',
    action: 'read',
    resource: 'Manager',
  },
  {
    title: 'Promoções',
    icon: mdiBrightnessPercent,
    to: 'manager-promocoes',
    action: 'read',
    resource: 'Manager',
  },
  {
    title: 'Pricing',
    icon: mdiCurrencyUsd,
    to: 'manager-pricing',
    action: 'read',
    resource: 'Manager',
  },
  {
    title: 'Ajuda',
    icon: mdiHelpCircle,
    to: 'manager-help',
    action: 'read',
    resource: 'Manager',
  },
]
